<template>
  <div class="invoice-list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="`${$t(`page.users.invoiceList.openedCount`)}(${openedCount})`" name="2"></el-tab-pane>
      <el-tab-pane :label="`${$t(`page.users.invoiceList.applyingCount`)}(${applyingCount})`" name="1"></el-tab-pane>
    </el-tabs>

    <div class="invoice-content" v-loading="loading">
      <!-- Table Header -->
      <div class="header-row">
        <div class="col col-info">{{ $t(`page.users.invoiceList.orderNum`) }}</div>
        <div class="col col-amount">{{ $t(`page.users.invoiceList.tableColumn.amount`) }}</div>
        <div class="col col-title">{{ $t(`page.users.invoiceList.tableColumn.title`) }}/{{ $t(`page.users.invoiceList.tableColumn.type`) }}</div>
        <div class="col col-status">{{ $t(`page.users.invoiceList.tableColumn.status`) }}</div>
        <div class="col col-actions">{{ $t(`page.users.invoiceList.tableColumn.actions`) }}</div>
      </div>

      <!-- List Items -->
      <div class="invoice-item" v-for="(item, index) in tableData" :key="index">
        <!-- <div class="item-header">
          <span class="mr-20">{{ $t(`page.users.invoiceList.orderNum`) }}：{{ item.orderSn }}</span>
          <span>{{ $t(`page.users.invoiceList.applicationTime`) }}：{{ item.date }}</span>
        </div> -->
        <div class="item-body">
          <div class="col col-info">
            <!-- <img :src="item.productImage" alt="" class="product-image"> -->
            <div class="product-name line2">{{ item.orderid }}</div>
          </div>
          <div class="col col-amount">
            <span class="amount">¥{{ item.amount }}</span>
          </div>
          <div class="col col-title">
            <span>{{ item.title + '/' }}{{ item.type == 1 ? $t(`page.users.invoiceList.tableColumn.type1`) : $t(`page.users.invoiceList.tableColumn.type2`) }}</span>
            <!-- <span></span> -->
          </div>
          <div class="col col-status">
            <div class="status-text" :class="{'green': item.status == 0}">{{ $t(`page.users.invoiceList.status[${item.status}]`) }}</div>
            <!-- <div v-if="item.status == 0" class="cancel-btn">{{ $t(`page.users.invoiceList.actionBtn.cancel`) }}</div> -->
          </div>
          <div class="col col-actions">
            <el-button type="text" class="action-btn" @click="viewInvoiceDetail(item)">{{ $t(`page.users.invoiceList.actionBtn.viewInvoice`) }}</el-button>
            <el-button type="text" class="action-btn" @click="viewOrderDetail(item)">{{ $t(`page.users.invoiceList.actionBtn.orderDetails`) }}</el-button>
          </div>
        </div>
      </div>
      <div class="empty-box" v-if="tableData.length == 0 && !loading">
        <img src="@/assets/images/noorder.png" alt="">
        <p>{{$t(`page.users.orderList.empty`)}}~</p>
      </div>
    </div>

    <div class="pagination-container" v-if="total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next"
        :total="total"
        background
      >
      </el-pagination>
    </div>
    <!-- 发票详情弹窗 -->
    <invoice-detail-modal :visible.sync="showDetailModal" :invoice-id="currentInvoiceId"></invoice-detail-modal>
  </div>
</template>

<script>
import InvoiceDetailModal from '@/components/InvoiceDetailModal'

export default {
  components: {
    InvoiceDetailModal
  },
  data() {
    return {
      activeName: '2',
      openedCount: 0,
      applyingCount: 0,
      tableData: [],
      loading: true,
      currentPage: 1,
      total: 0,
      showDetailModal: false,
      currentInvoiceId: ''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClick(tab, event) {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$axios.post('/api/center/getInvoicelists', {
        page: this.currentPage,
        pageSize: 10,
        status: Number(this.activeName)
      }).then(res => {
        this.tableData = res.data.list;
        this.openedCount = res.data.invoice_num2;
        this.applyingCount = res.data.invoice_num1;
        this.total = res.data.total;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    viewInvoiceDetail(item) {
      this.currentInvoiceId = item.id
      this.showDetailModal = true
    },
    viewOrderDetail(item) {
      this.$router.push(`/order/order_detail?orderNo=${item.order_id}&orderStatus=${item.states}`)
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-list {
  padding: 20px;
  background-color: #fff;

  .invoice-content {
    margin-top: 20px;
  }

  .header-row {
    display: flex;
    background-color: #F7F7F7;
    padding: 10px 0;
    color: #333;
    font-weight: bold;
    font-size: 14px;
    
    .col {
      text-align: center;
    }
  }

  .col {
      &.col-info { flex: 1; }
      &.col-amount { flex: 1; }
      &.col-title { flex: 1; }
      &.col-status { flex: 1; }
      &.col-actions { flex: 1; }
  }

  .invoice-item {
    margin-top: 20px;
    border: 1px solid #EBEEF5;

    .item-header {
      background-color: #F7F7F7;
      padding: 10px 20px;
      color: #999;
      font-size: 13px;
      .mr-20 { margin-right: 40px; }
    }

    .item-body {
      display: flex;
      align-items: center;
      padding: 20px 0;
      color: #333;
      font-size: 14px;

      .col {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        
        &.col-info {
          flex-direction: row;
          align-items: center;
          
          .product-image {
            width: 80px;
            height: 80px;
            margin-right: 15px;
            border-radius: 4px;
          }
          .product-name {
            flex: 1;
            // line-height: 1.5;
          }
        }

        &.col-amount {
          .amount { font-weight: bold; font-size: 16px; }
        }

        &.col-title {
           line-height: 1.8;
           color: #666;
        }

        &.col-status {
           .status-text {
               margin-bottom: 5px;
               &.green {
                   background-color: #E2F5EA;
                   color: #1DBF66;
                   padding: 2px 8px;
                   border-radius: 2px;
                   display: inline-block;
                   font-size: 12px;
               }
           }
           .cancel-btn {
               font-size: 12px;
               color: #666;
               cursor: pointer;
               &:hover { color: #E93323; }
           }
        }
        
        &.col-actions {
            .action-btn {
                margin: 0;
                padding: 5px 0;
                color: #666;
                &:hover { color: #E93323; }
                
                &.is-details {
                    background: #F7F7F7;
                    padding: 5px 15px;
                    border-radius: 4px;
                    margin-bottom: 5px;
                }
            }
        }
      }
    }
  }

  .pagination-container {
    margin-top: 30px;
    text-align: right;
  }
  
  .empty-box {
      text-align: center;
      padding: 50px 0;
      img { width: 150px; }
      p { color: #999; margin-top: 20px; }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #E93323;
  }
  ::v-deep .el-tabs__active-bar {
      background-color: #E93323;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #E93323;
  }
}
</style>